var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"footer-inner"},[_c('p',[_vm._v("© 2013 - "+_vm._s(new Date().getFullYear())+" Altezza Travel")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }